/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Access_DescriptionInputs */

const en_customer_access_description = /** @type {(inputs: Customer_Access_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate a magic login link for customer account support workflows.`)
};

const es_customer_access_description = /** @type {(inputs: Customer_Access_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genera un link magico para soporte de cuentas de clientes.`)
};

/**
* | output |
* | --- |
* | "Generate a magic login link for customer account support workflows." |
*
* @param {Customer_Access_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const customer_access_description = /** @type {((inputs?: Customer_Access_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Access_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_customer_access_description(inputs)
	return es_customer_access_description(inputs)
});